export default "/images/8dbf1be1ea3e6f828a7f96deb512787e.avif";